var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreyLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 165,
    height: 62.53,
    viewBox: "0 0 165 62.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 165,
    height: 62.53,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149",
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M2.9,207.528a9.975,9.975,0,0,1,7.1-2.763,9.871,9.871,0,0,1,7.027,2.729,8.845,8.845,0,0,1,2.866,6.72,9.047,9.047,0,0,1-2.9,6.857A10.011,10.011,0,0,1,9.927,223.8a9.868,9.868,0,0,1-7.061-2.7A9.435,9.435,0,0,1,2.9,207.528m3.855,10.1a4.4,4.4,0,0,0,3.207,1.3,4.43,4.43,0,0,0,4.469-4.673,4.527,4.527,0,0,0-1.3-3.309,4.3,4.3,0,0,0-3.207-1.33,4.224,4.224,0,0,0-3.172,1.33,4.526,4.526,0,0,0-1.3,3.309,4.687,4.687,0,0,0,1.3,3.377",
    transform: "translate(0 -182.129)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M196.41,207.977h.068a6.45,6.45,0,0,1,5.56-2.593,7.767,7.767,0,0,1,6.243,2.865,9.918,9.918,0,0,1,2.422,6.55,9.815,9.815,0,0,1-2.49,6.618,8,8,0,0,1-6.311,2.866,6.623,6.623,0,0,1-5.39-2.354h-.068v6.1h-5.322v-22.3h4.18Zm1.194,10.2a4.614,4.614,0,0,0,6.413,0,4.686,4.686,0,0,0,1.3-3.377,4.487,4.487,0,0,0-4.537-4.605,4.323,4.323,0,0,0-3.172,1.3,4.527,4.527,0,0,0-1.3,3.309,4.687,4.687,0,0,0,1.3,3.377",
    transform: "translate(-169.994 -182.68)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M383.655,215.475a4.274,4.274,0,0,0,4.5,3.582,4.878,4.878,0,0,0,4.059-2.183l3.855,2.524c-1.535,2.763-4.128,4.128-7.846,4.128a10.155,10.155,0,0,1-7.13-2.661,9.06,9.06,0,0,1-2.865-6.891,9.153,9.153,0,0,1,2.831-6.72,9.4,9.4,0,0,1,6.822-2.8,8.658,8.658,0,0,1,9.074,9.108c0,.853-.034,1.5-.068,1.91Zm7.982-3.513a3.6,3.6,0,0,0-3.889-3.172,4.058,4.058,0,0,0-3.957,3.172Z",
    transform: "translate(-336.419 -181.855)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M572.983,223.94v-10.1c0-2.149-1.092-3.548-3.172-3.548-2.149,0-3.275,1.535-3.275,3.548v10.1h-5.321V205.724h4.18l1.107,2.388h.034a4.755,4.755,0,0,1,1.808-1.774,5.93,5.93,0,0,1,3.343-.955,5.837,5.837,0,0,1,4.912,2.081,7.92,7.92,0,0,1,1.671,5.151V223.94Z",
    transform: "translate(-499.174 -182.679)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 1.831,
    height: 62.53,
    transform: "translate(85.109)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M1254.467,156.8A13.932,13.932,0,1,0,1268.4,170.73a13.931,13.931,0,0,0-13.932-13.932m0,21.1a7.173,7.173,0,1,1,7.173-7.173,7.173,7.173,0,0,1-7.173,7.173",
    transform: "translate(-1103.398 -139.465)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M1039.733,156.882a16.344,16.344,0,0,1,5.674,6.1h4.883v21.6H1057l-.011-21.6h4.884a16.343,16.343,0,0,1,5.674-6.1Z",
    transform: "translate(-924.794 -139.539)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M859.04,173.653a7.173,7.173,0,1,1,0-5.847h7.073a13.932,13.932,0,1,0,0,5.847Z",
    transform: "translate(-745.858 -139.465)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyLogo);
export default __webpack_public_path__ + "static/media/Grey_logo.4d133329c3142fba27fbf65672ea4648.svg";
export { ForwardRef as ReactComponent };